import React, { FC, useState } from "react";
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";

import { ModalWrapper } from "components/common/ModalWrapper/ModalWrapper";
import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { useCartItemCountById } from "store/slices/cart/cart.selectors";
import { decrease, increase } from "store/slices/cart/cart.slice";
import { ProductStores } from "./ProductStores";

import Style from "./Style.module.scss";

type TVariant = "card" | "details";

interface IProps {
  product: TGetAllStoreProductsData;
  variant?: TVariant;
}

const CartControls: FC<IProps> = ({ product, variant = "card" }) => {
  const count = useCartItemCountById(product.id);
  const isEmpty = count === 0;

  return isEmpty ? (
    <AddToCart product={product} />
  ) : (
    <CartQuantityControls product={product} variant={variant} />
  );
};

export { CartControls };

interface IAddToCartProps {
  product: TGetAllStoreProductsData;
}

const AddToCart: FC<IAddToCartProps> = ({ product }) => {
  const [isProductStoresModalOpen, setIsProductStoresModalOpen] =
    useState<boolean>(false);

  return (
    <>
      <button
        className={Style.addButton}
        onClick={() => setIsProductStoresModalOpen(true)}
      >
        افزودن به سبد خرید
      </button>
      <ModalWrapper
        isOpen={isProductStoresModalOpen}
        toggle={() => setIsProductStoresModalOpen(false)}
        title="انتخاب اتاق"
      >
        <ProductStores product={product} />
      </ModalWrapper>
    </>
  );
};

interface ICartQuantityControlsProps {
  product: TGetAllStoreProductsData;
  variant: TVariant;
}

const CartQuantityControls: FC<ICartQuantityControlsProps> = ({
  product,
  variant,
}) => {
  const dispatch = useDispatch();
  const count = useCartItemCountById(product.id);
  const increment = () => dispatch(increase(product.id));
  const decrement = () => dispatch(decrease(product.id));

  const isLastItem = count === 1;

  return (
    <div className={`${Style.counter} ${Style[variant]}`}>
      <button
        onClick={increment}
      >
        <FaPlus />
      </button>

      <span>{count}</span>

      <button onClick={decrement}>
        {isLastItem ? <FaTrash className={Style.trash} /> : <FaMinus />}
      </button>
    </div>
  );
};
